export const SIDEBAR_TASK_DETAIL = 'taskDetail';
